import { Component, HostListener, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { ProgressoService, Progresso } from 'maestro-ng';
import { filter } from 'rxjs/operators';
import { AutenticacaoService } from './autenticacao/autenticacao.service';
import { PrimeNGConfig } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { FonteDadosMensagemErroService } from './fonte-dados/fonte-dados-mensagem-erro.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  public mobileView = null;
  public listaDeRotasPermitidas = [];

  constructor(
    private router: Router,
    private progressoService: ProgressoService,
    private autenticacaoService: AutenticacaoService,
    private primengConfig: PrimeNGConfig,
    private translateService: TranslateService,
    public fonteDadosMensagemErroService: FonteDadosMensagemErroService
  ) {}

  ngOnInit(): void {
    this.translateService.setDefaultLang('pt');
    this.translateService.stream('ptBr').subscribe((data) => {
      this.primengConfig.setTranslation(data);
    });
    this.router.events.pipe(filter((event) => event instanceof NavigationStart)).subscribe((event) => {
      this.autenticacaoService.verificaPermissao(event);
    });
  }

  getProgresso(): Progresso {
    return this.progressoService.getProgresso();
  }

  @HostListener('window:resize', ['$event'])
  public onWindowResize(): void {
    this.checkWindowsWidth();
  }

  private checkWindowsWidth(): void {
    if (window.innerWidth > 991) {
      this.mobileView = false;
    } else {
      this.mobileView = true;
    }
  }

  public atualizarListaDeRotasPermitidas(lista): void {
    this.listaDeRotasPermitidas = lista;
  }

  public mostrarErros() {
    return this.fonteDadosMensagemErroService.mostrarModalDeErros;
  }

  public fecharModalDeErros() {
    this.fonteDadosMensagemErroService.mostrarModalDeErros = false;
    this.fonteDadosMensagemErroService.mensagensDeErro = [];
  }
}
